/*
 * 参考jira: http://confluence.mhs.local:8090/pages/viewpage.action?pageId=5179137
 *
 */

import { getQueryObj } from '@/authLib/tools'

var SJCL = require('@/vendor/sjcl')
SJCL.beware["CBC mode is dangerous because it doesn't protect message integrity."]()

export const IV = '72ba90dbddbe8b4913edac9e65302c8f'

function hmacSHA256 (key, requestData) {
  // eslint-disable-next-line
  var hasher = new SJCL.misc.hmac(key, SJCL.hash.sha256)
  return SJCL.codec.hex.fromBits(hasher.encrypt(requestData))
}

function sortedKey (queryString) {
  const obj = getQueryObj(queryString)
  const sortArr = Object.keys(obj).sort()
  let sortString = ''
  sortArr.forEach((item, index) => {
    const splice = index ? '&' : ''
    sortString += `${splice}${item}=${obj[item]}`
  })
  return sortString
}

function utf8StringToBits (str) {
  return SJCL.codec.utf8String.toBits(str)
}

export function aesEncrypt (str, key, iv = IV, sourceEncode = 'utf8String') {
  // eslint-disable-next-line
  const aes = new SJCL.cipher.aes(SJCL.codec.hex.toBits(key))
  // eslint-disable-next-line
  str = SJCL.codec[sourceEncode].toBits(str)
  const encrypted = SJCL.mode.cbc.encrypt(aes, str, SJCL.codec.hex.toBits(iv))
  return SJCL.codec.base64.fromBits(encrypted)
}

export function aesDecrypt (cipherText, key, iv = IV, sourceEncode = 'base64') {
  // eslint-disable-next-line
  const aes = new SJCL.cipher.aes(SJCL.codec.hex.toBits(key))
  let decrypted
  let result
  // eslint-disable-next-line
  cipherText = SJCL.codec[sourceEncode].toBits(cipherText)

  try {
    decrypted = SJCL.mode.cbc.decrypt(aes, cipherText, SJCL.codec.hex.toBits(iv))
    result = SJCL.codec.utf8String.fromBits(decrypted)
  } catch (e) {
    result = e
  }
  return result
}

export function getTempKey (req, terminalKey, platform, rankey) {
  var tmpKey = null
  if (!terminalKey || !req['x-antispams'] || !req['x-device'] || !req['x-timestamp']) {
    const err = new Error('missing parameter in headers')
    throw err
  }
  if (platform === 'app') {
    tmpKey = terminalKey + req['x-antispams'] + req['x-device'] + req['x-timestamp']
  } else {
    tmpKey = terminalKey + req['x-device'] + req['x-antispams'] + req['x-timestamp']
  }
  // console.log('platform', platform)
  // console.log('terminalKey', terminalKey)
  // console.log('rndkey', rankey)
  // console.log('tmpKey', tmpKey)
  if (rankey) {
    tmpKey = SJCL.codec.hex.toBits(rankey + SJCL.codec.hex.fromBits(SJCL.hash.sha256.hash(tmpKey)))
  } else {
    tmpKey = SJCL.hash.sha256.hash(tmpKey)
  }
  return tmpKey
}

export function getSignKey (req, terminalKey, platform, cookie) {
  let requestData = null
  const {
    method,
    allUrl,
    urlPath
  } = req
  let bodyData = req.data
  const sortedQueryString = (allUrl && sortedKey(allUrl)) || ''
  // need url path eg. /v1/ha/ha/sdfsdf
  if (!method || !req['x-host'] || !urlPath || !req['x-requestid']) {
    const err = new Error('missing parameter in headers')
    throw err
  }
  // eslint-disable-next-line
  requestData = method.toUpperCase() + req['x-host'] + urlPath + sortedQueryString + req['x-requestid']
  if (platform === 'app') {
  // eslint-disable-next-line
    requestData = requestData + req['x-timestamp'] + req['x-device'] + req['x-product'] + req['x-antispams']
  } else {
    // eslint-disable-next-line
    requestData = requestData + req['x-device'] + req['x-product'] + req['x-antispams'] + req['x-timestamp']
  }
  requestData = requestData + req['content-type'] + req['accept-language']
  // console.log('requestData||query=', requestData)
  // 目前只考虑了 json 类型数据; 空对象不加入签名；
  if (Object.keys(bodyData).length && method.toUpperCase() === 'POST') {
    bodyData = JSON.stringify(bodyData)
    requestData = requestData + bodyData
  }
  // console.log('requestData||bodyData=', requestData)
  const tempKey = getTempKey(req, terminalKey, platform, cookie)
  return hmacSHA256(tempKey, utf8StringToBits(requestData))
}
